import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Select from 'react-select';
import { push } from 'react-router-redux';
import UserDropdownButton from '../../buttons/UserDropdownButton';
import GoToDropdownButton from '../../buttons/GoToDropdownButton';
import QuickAddDropdownButton from '../../buttons/QuickAddDropdownButton';
import GetStartedDropdownButton from '../../buttons/GetStartedDropdownButton';
import SearchTypeAhead from '../../inputs/SearchTypeAhead';
import NotificationsButton from '../../buttons/NotificationsButton';
import Logo from '../../ui/Logo';

import 'react-select/dist/react-select.css';
import '../../../styles/NavBar.css';

import faPlus from '@fortawesome/fontawesome-pro-light/faPlus';

// if (__CLIENT__) {
//   require('react-select/dist/react-select.css');

// }

class NavBarProjectDropdown extends Component {
  static propTypes = {
    projects: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func.isRequired,
    currentProjectId: PropTypes.string,
  };

  state = {
    selectedValue: null,
  };

  _onChange = ({ value }) => {
    const { dispatch } = this.props;
    this.setState({ selectedValue: value });
    dispatch(push(`/project/${value}`));
  };

  render() {
    const { currentProjectId, projects } = this.props;
    const options =
      projects &&
      projects
        .sortBy(p => p.get('name'))
        .map(p => ({ label: p.get('name'), value: p.get('id') }))
        .valueSeq()
        .toArray();
    return (
      <Select
        style={{ width: 300 }}
        options={options}
        onChange={this._onChange}
        clearable={false}
        placeholder="Change project..."
        value={this.state.selectedValue || currentProjectId}
      />
    );
  }
}

class NavBar extends Component {
  static propTypes = {
    user: PropTypes.instanceOf(Map),
    projects: PropTypes.instanceOf(Map),
    taskTypeId: PropTypes.string,
    userMode: PropTypes.string,
    elementTypes: PropTypes.instanceOf(Map),
    userRoles: PropTypes.instanceOf(Map),
    routing: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    currentAccountId: PropTypes.string,
    currentOrganizationId: PropTypes.string,
    currentProjectId: PropTypes.string,
    routeParams: PropTypes.object,
  };

  render() {
    const {
      user,
      elementTypes,
      dispatch,
      routing,
      currentAccountId,
      currentOrganizationId,
      currentProjectId,
      userMode,
      taskTypeId,
      projects,
      routeParams,
      userRoles,
    } = this.props;

    return (
      <nav className="navbar navbar-expand-md navbar-light bg-faded navbar-border">
        <Logo />
        <NavBarProjectDropdown
          projects={projects}
          dispatch={dispatch}
          currentProjectId={currentProjectId}
        />
        <GetStartedDropdownButton
          currentAccountId={currentAccountId}
          currentOrganizationId={currentOrganizationId}
          userRoles={userRoles}
        />
        <div className="collapse navbar-collapse">
          <ul className="navbar-nav mr-auto" />
          <ul className="navbar-nav">
          {routeParams &&
              routeParams.projectId && (
                <SearchTypeAhead
                  dispatch={dispatch}
                  currentProjectId={currentProjectId}
                />
              )}
            {routeParams &&
              routeParams.projectId && (
                <QuickAddDropdownButton
                  user={user}
                  taskTypeId={taskTypeId}
                  userMode={userMode}
                  elementTypes={elementTypes}
                  routing={routing}
                  icon={faPlus}
                  dispatch={dispatch}
                />
              )}
            <GoToDropdownButton
              currentAccountId={currentAccountId}
              currentOrganizationId={currentOrganizationId}
              userRoles={userRoles}
            />
            <UserDropdownButton dispatch={dispatch} user={user} />
            <NotificationsButton />
          </ul>
        </div>
      </nav>
    );
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/toolbars/NavBar/NavBar.js